import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FormulasEffects } from './formulas.effects';
import { reducer } from './formulas.reducer';
import { FORMULAS_STATE_KEY } from './formulas.state';

/**
 * Registers the formula-function catalogue: the `formulas` feature slice and the effects that
 * fill it.
 *
 * Import it in the **root** module. `FormulasEffects` reacts to an action the runtime dispatches
 * once a page starts, and an effect registered after that action has gone by never sees it.
 */
@NgModule({
  imports: [
    StoreModule.forFeature(FORMULAS_STATE_KEY, reducer),
    EffectsModule.forFeature([FormulasEffects]),
  ],
})
export class FormulasStateModule {}
